/* OL - Slide-out basket (ol-cart). Markup and #CartTemplate: snippets/ol-cart.liquid. Styles: assets/ol-cart.css.
   The theme's basket engine (ajax-cart.min.js) still builds the items and handles quantities. This file:
   - opens and closes the drawer (instead of the old pop-up), with focus kept inside, Esc, the backdrop and a swipe to close
   - labels each line (service visit, included offer item, "For your <hot tub>"), shows "Free" for £0 lines
   - shows the add-ons and service visits that go with each item, from /products/<handle>?view=ol-cart-addons
   - shows the free delivery bar for small orders, and a service visits card for care-only baskets
   - highlights what was just added and keeps the scroll position when the basket redraws
   The basket lock (ol-campaign-offers.js) still sees every change, because quantities still go through ajax-cart. */
(function () {
  'use strict';
  var root = document.getElementById('OlCart');
  if (!root || root.__olCart) return;
  root.__olCart = true;

  var cfg = {};
  try { cfg = JSON.parse((document.getElementById('OlCartConfig') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
  var SVC = cfg.svcSkus || [];
  var FREE_TYPES = cfg.freeTypes || [];
  var CARE_TYPES = ['water care', 'chemicals', 'filters', 'service & parts', 'cleaning', 'accessories', 'cover accessories', 'aromatherapy'];
  var html = document.documentElement;
  var panel = root.querySelector('.ol-cart__panel');
  var isOpen = false, lastFocus = null, closeTimer = null, enterTimer = null;
  var prevQty = null, lastCart = null, scrollTop = 0, quietAdd = false;
  var expanded = {}, showAll = {}, cache = {}, pending = {};
  var TTL = 10 * 60 * 1000;

  function $() { return window.jQuery; }
  function money(c) {
    c = Number(c) || 0;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(c, cfg.money || '£{{amount}}');
    return '£' + (c / 100).toFixed(2);
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function base() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function isSvc(it) { return SVC.indexOf(it.sku) > -1; }
  function isGift(it) { return !!(it.properties && it.properties._ol_offer_item); }

  /* ---------- open and close ---------- */
  function scrollbarWidth() { return Math.max(0, window.innerWidth - html.clientWidth); }
  function open() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    html.style.setProperty('--ol-sbw', scrollbarWidth() + 'px');
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open', 'is-entering');
    html.classList.add('ol-cart-open');
    if (enterTimer) clearTimeout(enterTimer);
    enterTimer = setTimeout(function () { root.classList.remove('is-entering'); }, 900);
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }, reduced() ? 0 : 60);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open', 'is-entering');
    panel.style.transform = '';
    closeTimer = setTimeout(function () {
      root.hidden = true;
      html.classList.remove('ol-cart-open');
      html.style.removeProperty('--ol-sbw');
      closeTimer = null;
    }, reduced() ? 0 : 320);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }
  window.olCart = { open: open, close: close, isOpen: function () { return isOpen; } };

  function ajaxOn() { return !(window.theme && window.theme.cart_ajax === false); }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.js-cart-trigger') : null;
    if (!t || !ajaxOn()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
    /* The basket may have changed somewhere else (another tab), so redraw it from Shopify each time it's opened from the header */
    reload();
  }, true);
  /* Back/forward cache: a page restored from history can show an old basket */
  window.addEventListener('pageshow', function (e) { if (e.persisted) reload(); });

  function hookTheme() {
    if (window.theme && typeof window.theme.mfpOpen === 'function' && !window.theme.mfpOpen.__ol) {
      var orig = window.theme.mfpOpen;
      window.theme.mfpOpen = function (a) { if (a === 'cart') { open(); return; } return orig.apply(this, arguments); };
      window.theme.mfpOpen.__ol = true;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hookTheme); else hookTheme();
  window.addEventListener('load', hookTheme);

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ol-cart-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([readonly]), textarea, summary, [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Swipe right to close (touch only, only once the gesture is clearly sideways) */
  var sx = 0, sy = 0, dx = 0, drag = null;
  panel.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) return; sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; drag = null; }, { passive: true });
  panel.addEventListener('touchmove', function (e) {
    if (drag === false || e.touches.length !== 1) return;
    var x = e.touches[0].clientX - sx, y = e.touches[0].clientY - sy;
    if (drag === null) {
      if (Math.abs(x) < 12 && Math.abs(y) < 12) return;
      drag = x > 0 && Math.abs(x) > Math.abs(y) * 1.6 && !e.target.closest('textarea');
      if (!drag) return;
      root.classList.add('is-dragging');
    }
    dx = Math.max(0, x);
    panel.style.transform = 'translateX(' + dx + 'px)';
  }, { passive: true });
  panel.addEventListener('touchend', function () {
    if (!drag) { drag = null; return; }
    root.classList.remove('is-dragging');
    drag = null;
    if (dx > Math.min(120, panel.offsetWidth * 0.28)) close(); else panel.style.transform = '';
  });

  root.addEventListener('scroll', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ol-scroll')) scrollTop = e.target.scrollTop;
  }, true);

  /* ---------- status line (screen readers, and a short visible "Added") ---------- */
  var statusTimer = null;
  var ICON_OK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var ICON_RM = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>';
  function status(msg, kind) {
    var bar = root.querySelector('[data-ol-status]');
    if (!bar) return;
    /* The theme's basket container has a top z-index; sitting after it at the same level keeps the message on top */
    if (bar.parentNode && bar.parentNode.lastElementChild !== bar) bar.parentNode.appendChild(bar);
    bar.className = 'ol-cart__status ol-cart__status--' + (kind || 'ok');
    bar.innerHTML = '<span class="ol-cart__status-ic">' + (kind === 'rm' ? ICON_RM : ICON_OK) + '</span><span class="ol-cart__status-t">' + esc(msg) + '</span>' +
      '<button type="button" class="ol-cart__status-x" data-ol-status-x aria-label="Close message"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    void bar.offsetWidth;
    bar.classList.add('is-on');
    if (statusTimer) clearTimeout(statusTimer);
    statusTimer = setTimeout(function () { bar.classList.remove('is-on'); }, 3200);
  }
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ol-status-x]')) return;
    var bar = root.querySelector('[data-ol-status]');
    if (bar) bar.classList.remove('is-on');
    if (statusTimer) clearTimeout(statusTimer);
  });

  /* ---------- add-on data ---------- */
  function readStore(h) {
    try { var r = JSON.parse(sessionStorage.getItem('olcx:' + h) || 'null'); if (r && Date.now() - r.at < TTL) return r.d; } catch (e) { /* storage blocked */ }
    return null;
  }
  function getData(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    var s = readStore(h);
    if (s) { cache[h] = s; return Promise.resolve(s); }
    if (pending[h]) return pending[h];
    pending[h] = fetch(base() + 'products/' + encodeURIComponent(h) + '?view=ol-cart-addons', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        var a = t.indexOf('<!--OLJ'), b = t.lastIndexOf('OLJ-->');
        if (a < 0 || b < 0) throw new Error('no data');
        var d = JSON.parse(t.slice(a + 7, b));
        d.a = d.a || []; d.s = d.s || [];
        cache[h] = d;
        try { sessionStorage.setItem('olcx:' + h, JSON.stringify({ at: Date.now(), d: d })); } catch (e) { /* ignore */ }
        return d;
      })
      .catch(function () { cache[h] = { a: [], s: [] }; return cache[h]; })
      .then(function (d) { delete pending[h]; return d; });
    return pending[h];
  }

  var SVC_IC = {
    c: '<path fill="#2a2322" d="M3 9h18v1.2H3zM4 10.2h16L18.8 15H5.2z"></path><path fill="#1d7f74" d="M9 2h6v1.2H9zM10.4 3.2h3.2v4.4h-3.2z"></path><path fill="#2a2322" d="M6 4h1.2v3H6zM16.8 4H18v3h-1.2z"></path>',
    s: '<path fill="#2a2322" d="M11.4 1h1.2v14h-1.2z"></path><path fill="#2a2322" d="M5.4 4.2l.6-1 12.6 7.6-.6 1zM5.4 11.8l12.6-7.6.6 1L6 12.8z"></path><circle fill="#1d7f74" cx="12" cy="8" r="2"></circle>',
    r: '<path fill="#2a2322" d="M5 1h14v14H5zm1.2 1.2v11.6h11.6V2.2z"></path><path fill="#1d7f74" d="M7.4 3.6h9.2v5H7.4z"></path><path fill="#2a2322" d="M7.4 10h9.2v1.1H7.4zM7.4 12h6v1.1h-6z"></path>'
  };
  var PLUS = '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"></path></svg>';

  function rowsFor(d, inCart, item) {
    var s = d.s.filter(function (x) { return !inCart[x.v]; });
    var a = d.a.filter(function (x) { return !inCart[x.v]; });
    return { s: s, a: a };
  }

  function renderExtras(slot, item, d, inCart, forceOpen) {
    var r = rowsFor(d, inCart, item);
    var total = r.s.length + r.a.length;
    if (!total) { slot.innerHTML = ''; slot.hidden = true; return; }
    slot.hidden = false;
    var h = item.handle;
    var isOpenX = expanded[h] !== undefined ? expanded[h] : !!forceOpen;
    var label = r.s.length && r.a.length ? 'Add-ons and service visits' : (r.s.length ? 'Service visits for this hot tub' : 'Goes well with this');
    var thumbs = r.s.concat(r.a).filter(function (x) { return x.i; }).slice(0, 3).map(function (x) { return '<img src="' + esc(x.i) + '" alt="" width="24" height="24" loading="lazy">'; }).join('');
    if (!thumbs && r.s.length) thumbs = '<span class="ol-x__svcdot"><svg width="16" height="11" viewBox="0 0 24 16">' + SVC_IC.r + '</svg></span>';
    var id = 'olx-' + item.key.replace(/[^a-z0-9]/gi, '');
    var out = '<button type="button" class="ol-x__tog" aria-expanded="' + (isOpenX ? 'true' : 'false') + '" aria-controls="' + id + '" data-ol-x-tog="' + esc(h) + '">' +
      '<span class="ol-x__thumbs" aria-hidden="true">' + thumbs + '</span>' +
      '<span class="ol-x__lab">' + esc(label) + ' <span class="ol-x__n">' + total + '</span></span>' +
      '<svg class="ol-x__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg></button>';
    out += '<div class="ol-x__body" id="' + id + '"' + (isOpenX ? '' : ' hidden') + '>';
    if (r.s.length) {
      out += '<p class="ol-x__h">Look after your hot tub <span>We call you to pick a date</span></p><ul class="ol-x__list">';
      r.s.forEach(function (x) {
        out += '<li class="ol-x__row ol-x__row--svc">' +
          (x.i ? '<a class="ol-x__img" href="' + esc(x.u) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(x.i) + '" alt="" width="52" height="52" loading="lazy"></a>'
            : '<a class="ol-x__ic" href="' + esc(x.u) + '" tabindex="-1" aria-hidden="true"><svg width="30" height="20" viewBox="0 0 24 16">' + (SVC_IC[x.ic] || SVC_IC.r) + '</svg></a>') +
          '<span class="ol-x__t"><a href="' + esc(x.u) + '">' + esc(x.t) + '</a><small>' + esc(x.d) + '</small></span>' +
          '<span class="ol-x__p">' + money(x.p) + '</span>' +
          '<button type="button" class="ol-x__add" data-ol-add="' + x.v + '" data-ol-tub="' + esc(item.product_title) + '" data-ol-name="' + esc(x.t) + '" aria-label="Add ' + esc(x.t) + ' for ' + esc(item.product_title) + '">' + PLUS + '<span>Add</span></button></li>';
      });
      out += '</ul>';
    }
    if (r.a.length) {
      var all = !!showAll[h];
      out += (r.s.length ? '<p class="ol-x__h">Goes well with</p>' : '') + '<ul class="ol-x__list">';
      r.a.forEach(function (x, i) {
        var was = x.c && x.c > x.p ? '<s>' + money(x.c) + '</s>' : '';
        out += '<li class="ol-x__row"' + (!all && i >= 3 ? ' hidden' : '') + '>' +
          '<a class="ol-x__img" href="' + esc(x.u) + '" tabindex="-1" aria-hidden="true">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" width="52" height="52" loading="lazy">' : '') + '</a>' +
          '<span class="ol-x__t"><a href="' + esc(x.u) + '">' + esc(x.t) + '</a>' + (x.g === 'flt' ? '<small>Fits this hot tub</small>' : '') + '</span>' +
          '<span class="ol-x__p">' + was + money(x.p) + '</span>' +
          '<button type="button" class="ol-x__add" data-ol-add="' + x.v + '" data-ol-name="' + esc(x.t) + '" aria-label="Add ' + esc(x.t) + '">' + PLUS + '<span>Add</span></button></li>';
      });
      out += '</ul>';
      if (r.a.length > 3) out += '<button type="button" class="ol-x__more" data-ol-x-more="' + esc(h) + '">' + (all ? 'Show fewer' : 'Show ' + (r.a.length - 3) + ' more') + '</button>';
    }
    out += '</div>';
    slot.innerHTML = '<div class="ol-x' + (isOpenX ? ' is-open' : '') + '">' + out + '</div>';
  }

  /* ---------- enhance after every redraw ---------- */
  function lineTags(it, d) {
    var p = it.properties || {}, out = '';
    if (d && d.extra) out += '<span class="ol-tag">Extra, not part of the offer</span>';
    if (isGift(it) || (d && d.linked)) out += '<span class="ol-tag ol-tag--gift"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-2-4-6-4-6-1.5S10 7 12 7zm0 0c2-4 6-4 6-1.5S14 7 12 7z"></path></svg>' + ((d ? d.fin : it.final_line_price) > 0 ? 'Part of your package' : 'Included with your offer') + '</span>';
    if (isSvc(it)) out += '<span class="ol-tag ol-tag--svc"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1z"></path></svg>We call you to book a date</span>';
    Object.keys(p).forEach(function (k) {
      if (!k || k.charAt(0) === '_' || p[k] === '' || p[k] == null) return;
      if (k === 'Hot tub') out += '<span class="ol-tag">For your ' + esc(p[k]) + '</span>';
      else out += '<span class="ol-tag">' + esc(k) + ': ' + esc(p[k]) + '</span>';
    });
    return out;
  }

  /* Free delivery (checked against Shopify's own delivery rates on 4 Nov 2026): the General delivery profile (care products and
     accessories, cfg.freeTypes) is free when the whole basket comes to £50 or more after discounts, and £2.99 below that.
     Big items (hot tubs, swim spas, saunas, pergolas …) have their own delivery charges, so the bar only shows for baskets of
     care products and accessories, with or without a service visit. */
  function freeBar(cart) {
    var bar = root.querySelector('[data-ol-bar]');
    if (!bar) return;
    var goods = cart.items.filter(function (it) { return !isSvc(it); });
    var small = goods.filter(function (it) { return FREE_TYPES.indexOf(String(it.product_type || '').toLowerCase()) > -1; });
    var limit = Number(cfg.freeDel) || 0;
    if (!small.length || small.length < goods.length || !limit) { bar.hidden = true; bar.innerHTML = ''; return; }
    var total = Number(cart.total_price) || 0;
    var pct = Math.min(100, Math.round(total / limit * 100));
    var done = total >= limit;
    var tick = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"></path></svg>';
    bar.hidden = false;
    bar.className = 'ol-cart__bar' + (done ? ' is-done' : '');
    bar.innerHTML = '<p>' + (done ? tick + 'You qualify for free delivery' : 'Spend <b>' + money(limit - total) + '</b> more for free delivery') + '</p>' +
      '<span class="ol-cart__meter" role="progressbar" aria-label="Free delivery progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><i style="width:' + pct + '%"></i></span>';
  }

  /* Lowest service visit price (annual, drain clean fill, winterise). Liquid can't always read it (it depends on how many
     products the page has already looked up), so when the page didn't get it, it's read from the products and kept for 10 minutes. */
  var SVC_FROM = [['annual-hot-tub-service', 'Service OEM'], ['hot-tub-cleaning-service', 'DCR'], ['hot-tub-winterising-service', 'DW']];
  var svcFromP = null;
  function svcFrom() {
    if (Number(cfg.svcFrom) > 0) return Promise.resolve(Number(cfg.svcFrom));
    if (svcFromP) return svcFromP;
    try {
      var c = JSON.parse(sessionStorage.getItem('olSvcFrom') || 'null');
      if (c && c.t > Date.now() - TTL && c.v > 0) { cfg.svcFrom = c.v; return Promise.resolve(c.v); }
    } catch (e) { /* ignore */ }
    svcFromP = Promise.all(SVC_FROM.map(function (x) {
      return fetch(base() + 'products/' + x[0] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var v = p && (p.variants || []).filter(function (v) { return v.sku === x[1] && v.available !== false; })[0];
          return v ? Number(v.price) || 0 : 0;
        }).catch(function () { return 0; });
    })).then(function (ps) {
      var m = 0;
      ps.forEach(function (n) { if (n > 0 && (!m || n < m)) m = n; });
      if (m > 0) { cfg.svcFrom = m; try { sessionStorage.setItem('olSvcFrom', JSON.stringify({ t: Date.now(), v: m })); } catch (e) { /* ignore */ } }
      return m;
    });
    return svcFromP;
  }
  function emptySvc() {
    var card = root.querySelector('[data-ol-svc-empty]');
    if (!card || Number(cfg.svcFrom) > 0) return;
    svcFrom().then(function (m) {
      if (!m) return;
      var t = card.querySelector('[data-ol-svc-from]');
      if (t) t.textContent = money(m).replace(/\.00(?=\D*$)/, '');
      card.style.display = '';
    });
  }
  emptySvc();

  function afterCard(cart) {
    var slot = root.querySelector('[data-ol-after]');
    if (!slot) return;
    if (!(Number(cfg.svcFrom) > 0)) {
      svcFrom().then(function (m) { if (m > 0 && lastCart === cart) afterCard(cart); });
      slot.innerHTML = '';
      return;
    }
    var hasSvc = cart.items.some(isSvc);
    var hasTub = cart.items.some(function (it) { var t = String(it.product_type || '').toLowerCase(); return t === 'hot tub' || t === 'swim spas'; });
    var care = cart.items.some(function (it) { return CARE_TYPES.indexOf(String(it.product_type || '').toLowerCase()) > -1; });
    if (!cfg.svcFrom || hasSvc || hasTub || !care) { slot.innerHTML = ''; return; }
    slot.innerHTML = '<a class="ol-cart__svc-card" href="' + esc(cfg.hub || '/pages/hot-tub-servicing') + '">' +
      '<span class="ol-cart__svc-ic" aria-hidden="true"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1d7f74" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.4-.6-.6-2.4z"></path></svg></span>' +
      '<span class="ol-cart__svc-t"><b>Need a hand with your hot tub?</b><small>Service visits from ' + money(cfg.svcFrom).replace(/\.00(?=\D*$)/, '') + '. Our engineers come to you.</small></span>' +
      '<svg class="ol-cart__go" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M9 6l6 6-6 6"></path></svg></a>';
  }

  /* Show each included offer item and each service visit inside the card of the product it belongs to.
     Only the order on screen changes: every line keeps its own data-line, so quantities still work. */
  function group(cart) {
    var list = root.querySelector('.ol-cart__items');
    if (!list) return;
    var arts = {}, mains = {}, tubs = {};
    cart.items.forEach(function (it, i) {
      var a = list.querySelector('.ajaxcart__product[data-line="' + (i + 1) + '"]');
      if (!a) return;
      arts[i] = a;
      var p = it.properties || {};
      if (p._ol_campaign && !p._ol_offer_item && mains[p._ol_campaign] === undefined) mains[p._ol_campaign] = i;
      if (!isGift(it) && !isSvc(it) && tubs[it.product_title] === undefined) tubs[it.product_title] = i;
    });
    var after = {};
    cart.items.forEach(function (it, i) {
      var p = it.properties || {}, host;
      if (isGift(it)) host = mains[p._ol_campaign];
      else if ((cart.__olLinked || {})[i] !== undefined) host = cart.__olLinked[i];
      else if (isSvc(it) && p['Hot tub']) host = tubs[p['Hot tub']];
      if (host === undefined || host === i || !arts[host]) return;
      (after[host] = after[host] || []).push(i);
      arts[i].classList.add('ol-ci--child');
      /* Already shown inside its product's card, so "For your …" or "Fitted to: …" would only repeat it */
      Array.prototype.forEach.call(arts[i].querySelectorAll('.ol-tag'), function (t) {
        var x = t.textContent;
        if (x.indexOf('For your ') === 0 || x.indexOf('Fitted to: ') === 0) t.parentNode.removeChild(t);
      });
    });
    Object.keys(after).forEach(function (host) {
      var h = arts[host], slot = h.querySelector('[data-ol-extras]');
      var lk = cart.__olLinked || {};
      var first = function (i) { return isGift(cart.items[i]) || lk[i] !== undefined ? 0 : 1; };
      after[host].sort(function (a, b) { return first(a) - first(b) || a - b; });
      after[host].forEach(function (i) { h.insertBefore(arts[i], slot); });
      h.classList.add('ol-ci--host');
    });
  }

  /* Shopify can put an offer's discount on any line of the same product. If a customer adds one more IcePOD (or a second 12kW
     heat pump next to the 13ft Active package) on top of the included one, the extra line can come back with the offer price and
     the included line at full price. The total is right, but it reads wrong. So, per product, the offer's own discount
     ("Campaign | …" automatic discounts) is shown on the included lines and the extra lines carry the rest.
     Free gifts show as Free, package items at their package price. The basket total never changes. */
  function campaignOff(it) {
    var off = 0;
    (it.line_level_discount_allocations || []).forEach(function (a) {
      var t = a.discount_application && a.discount_application.title || '';
      if (/^Campaign\b/i.test(t)) off += Number(a.amount) || 0;
    });
    return off;
  }
  /* A package item added on its own (for example the 12kW heat pump added from its own page after the 13ft Active swim spa) has
     no offer properties, but Shopify still gives it the offer price. It is linked to its main product when it carries a
     "Campaign | …" discount whose title also shows on that main product's line or on one of its included items.
     Returns { line index: host line index }. Products that also have an included (gift) line are left to displayPrices. */
  function campTitles(it) {
    var t = {};
    (it.line_level_discount_allocations || []).forEach(function (a) {
      var x = a.discount_application && a.discount_application.title || '';
      if (/^Campaign\b/i.test(x)) t[x] = 1;
    });
    return t;
  }
  function linked(cart) {
    var hostOf = {}, byTitle = {}, giftVar = {};
    cart.items.forEach(function (it, i) {
      var p = it.properties || {};
      if (isGift(it)) giftVar[it.variant_id] = 1;
      if (!p._ol_campaign) return;
      var host = i;
      if (isGift(it)) {
        host = undefined;
        cart.items.forEach(function (m, j) { var q = m.properties || {}; if (host === undefined && q._ol_campaign === p._ol_campaign && !isGift(m)) host = j; });
      }
      if (host === undefined) return;
      Object.keys(campTitles(it)).forEach(function (x) { if (byTitle[x] === undefined) byTitle[x] = host; });
    });
    cart.items.forEach(function (it, i) {
      var p = it.properties || {};
      if (isGift(it) || isSvc(it) || p._ol_campaign || giftVar[it.variant_id] || !campaignOff(it)) return;
      Object.keys(campTitles(it)).forEach(function (x) { if (hostOf[i] === undefined && byTitle[x] !== undefined && byTitle[x] !== i) hostOf[i] = byTitle[x]; });
    });
    return hostOf;
  }
  function displayPrices(cart) {
    var dp = cart.items.map(function (it) { return { fin: Number(it.final_line_price) || 0, orig: Number(it.original_line_price) || 0, extra: false, linked: false }; });
    var lk = cart.__olLinked || {};
    Object.keys(lk).forEach(function (i) { dp[i].linked = true; });
    /* Same product next to a linked package line, without the offer price: that one is the extra */
    cart.items.forEach(function (it, i) {
      if (dp[i].linked || isGift(it) || isSvc(it) || (it.properties || {})._ol_campaign) return;
      var sib = Object.keys(lk).some(function (j) { return cart.items[j].variant_id === it.variant_id; });
      if (sib) dp[i].extra = true;
    });
    var groups = {};
    cart.items.forEach(function (it, i) { if (!isSvc(it)) (groups[it.variant_id] = groups[it.variant_id] || []).push(i); });
    Object.keys(groups).forEach(function (v) {
      var g = groups[v];
      var gifts = g.filter(function (i) { return isGift(cart.items[i]); });
      var plain = g.filter(function (i) { return !isGift(cart.items[i]); });
      if (!gifts.length || !plain.length) return;
      plain.forEach(function (i) { dp[i].extra = true; });
      var total = 0, giftQty = 0, plainQty = 0, campOff = 0, otherOffGifts = 0;
      g.forEach(function (i) { total += dp[i].fin; campOff += campaignOff(cart.items[i]); });
      gifts.forEach(function (i) { giftQty += cart.items[i].quantity; });
      plain.forEach(function (i) { plainQty += cart.items[i].quantity; });
      if (!campOff) {
        /* No offer discount found by name: fall back to free units by line */
        var freeUnits = 0;
        g.forEach(function (i) { if (dp[i].fin === 0) freeUnits += cart.items[i].quantity; });
        if (freeUnits < giftQty) return;
        var unit = cart.items[g[0]].original_price || 0;
        campOff = unit * giftQty;
      }
      /* Each included unit gets its share of the offer discount; other discounts stay with the line they are on */
      var giftsSum = 0;
      gifts.forEach(function (i) {
        var it = cart.items[i];
        var share = Math.round(campOff * it.quantity / giftQty);
        var own = (Number(it.original_line_price) || 0) - (Number(it.final_line_price) || 0) - campaignOff(it);
        var f = Math.max(0, (Number(it.original_line_price) || 0) - share - Math.max(0, own));
        dp[i].fin = Math.min(f, Number(it.original_line_price) || 0);
        giftsSum += dp[i].fin;
      });
      var left = total - giftsSum;
      if (left < 0) return; /* doesn't add up: leave Shopify's own split */
      plain.forEach(function (i, n) {
        var share = n === plain.length - 1 ? left : Math.round((total - giftsSum) * cart.items[i].quantity / plainQty);
        dp[i].fin = share; left -= share;
      });
    });
    /* One offer, several included items (for example the 13ft Active package: 12kW heat pump at its package price plus a free
       IcePOD). Shopify can book the whole offer saving on one of them (all £1,398 on the heat pump, the IcePOD at £199). Within
       each offer, the saving is shown cheapest item first, so a free gift always reads Free and the package item carries the
       rest. Extras the customer added on top are not part of the group. The group's total never changes. */
    var offerOf = {};
    cart.items.forEach(function (it, i) {
      if (isSvc(it) || dp[i].extra) return;
      var p = it.properties || {};
      if (isGift(it) && p._ol_campaign) offerOf[i] = p._ol_campaign;
      else if (lk[i] !== undefined) { var hp = cart.items[lk[i]].properties || {}; offerOf[i] = hp._ol_campaign || ('host' + lk[i]); }
    });
    var offers = {};
    Object.keys(offerOf).forEach(function (i) { (offers[offerOf[i]] = offers[offerOf[i]] || []).push(Number(i)); });
    Object.keys(offers).forEach(function (k) {
      var g = offers[k];
      if (g.length < 2) return;
      var paid = 0, saving = 0;
      g.forEach(function (i) { paid += dp[i].fin; saving += dp[i].orig - dp[i].fin; });
      if (saving <= 0) return;
      g.sort(function (a, b) { return (dp[a].orig / (cart.items[a].quantity || 1)) - (dp[b].orig / (cart.items[b].quantity || 1)) || a - b; });
      g.forEach(function (i) {
        var take = Math.min(saving, dp[i].orig);
        dp[i].fin = dp[i].orig - take; saving -= take;
      });
    });
    return dp;
  }
  function paintPrice(art, d) {
    var box = art.querySelector(':scope > .ajaxcart__row [data-ol-price]');
    if (!box) return;
    var off = d.orig > d.fin;
    box.innerHTML = (off ? '<s class="ol-ci__was"><span class="money">' + money(d.orig) + '</span></s>' : '') +
      '<span class="ol-ci__now' + (off ? '' : ' ol-ci__now--plain') + '">' + (d.fin === 0 ? 'Free' : '<span class="money">' + money(d.fin) + '</span>') + '</span>';
  }

  function enhance(cart) {
    setTimeout(unlock, 250);
    if (!cart || !Array.isArray(cart.items)) return;
    lastCart = cart;
    var cnt = root.querySelector('[data-ol-count]');
    if (cnt) cnt.textContent = cart.item_count ? '(' + cart.item_count + (cart.item_count === 1 ? ' item)' : ' items)') : '';
    var now = {}, fresh = [];
    cart.items.forEach(function (it) {
      now[it.key] = it.quantity;
      if (prevQty && (!(it.key in prevQty) || it.quantity > prevQty[it.key])) fresh.push(it.key);
    });
    var hadPrev = prevQty !== null;
    prevQty = now;
    if (!cart.item_count) return;

    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.variant_id] = 1; });
    var eligible = cart.items.filter(function (it) { return !isGift(it) && !isSvc(it); });
    var quiet = quietAdd; quietAdd = false;

    cart.__olLinked = linked(cart);
    var dp = displayPrices(cart);
    cart.items.forEach(function (it, i) {
      var art = root.querySelector('.ajaxcart__product[data-line="' + (i + 1) + '"]');
      if (!art) return;
      art.style.setProperty('--i', Math.min(i, 8));
      var tags = art.querySelector('[data-ol-tags]');
      if (tags) tags.innerHTML = lineTags(it, dp[i]);
      paintPrice(art, dp[i]);
      if (isGift(it) || dp[i].linked) art.classList.add('ol-ci--gift');
      if (isSvc(it)) art.classList.add('ol-ci--svc');
      var isNew = hadPrev && fresh.indexOf(it.key) > -1;
      if (isNew) art.classList.add('is-new');
      var slot = art.querySelector('[data-ol-extras]');
      if (!slot) return;
      if (isGift(it) || isSvc(it) || dp[i].linked || !it.handle) { slot.hidden = true; return; }
      var forceOpen = (isNew && !quiet) || eligible.length === 1;
      if (cache[it.handle]) renderExtras(slot, it, cache[it.handle], inCart, forceOpen);
      else {
        slot.hidden = true;
        getData(it.handle).then(function (d) {
          if (lastCart !== cart || !slot.isConnected) return;
          renderExtras(slot, it, d, inCart, forceOpen);
          if (slot.firstChild) slot.classList.add('is-in');
        });
      }
    });

    group(cart);
    freeBar(cart);
    afterCard(cart);

    var sc = root.querySelector('[data-ol-scroll]');
    if (sc) {
      var firstNew = hadPrev && !quiet && fresh.length ? root.querySelector('.ajaxcart__product.is-new') : null;
      if (firstNew && isOpen) {
        sc.scrollTop = Math.max(0, firstNew.offsetTop - 8);
      } else {
        sc.scrollTop = scrollTop;
      }
      scrollTop = sc.scrollTop;
    }
  }

  function bindJq() {
    var jq = $();
    if (!jq) return false;
    jq(document.body).on('afterCartLoad.ajaxCart', function (e, cart) { enhance(cart); });
    return true;
  }
  if (!bindJq()) document.addEventListener('DOMContentLoaded', bindJq);

  function reload() {
    if (window.ajaxCart && typeof ajaxCart.load === 'function') ajaxCart.load(); else unlock();
    if (typeof window.olUpdateCartCount === 'function') window.olUpdateCartCount();
  }

  /* One change at a time: while the basket is updating, taps on quantity, remove, add and clear wait.
     Stops a quick second tap landing on a line that has just moved. Released when the basket has redrawn. */
  var lockTimer = null;
  function lock() {
    root.classList.add('is-locked');
    if (lockTimer) clearTimeout(lockTimer);
    lockTimer = setTimeout(unlock, 8000);
  }
  function unlock() {
    if (lockTimer) { clearTimeout(lockTimer); lockTimer = null; }
    root.classList.remove('is-locked');
  }
  root.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.ajaxcart__qty-adjust, .ajaxcart__remove, [data-ol-add], [data-ol-clear]');
    if (!t) return;
    if (root.classList.contains('is-locked') || html.classList.contains('ol-cart-syncing')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    lock();
  }, true);

  /* ---------- clicks inside the basket ---------- */
  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) return;
    var tog = e.target.closest('[data-ol-x-tog]');
    if (tog) {
      var h = tog.getAttribute('data-ol-x-tog');
      var on = tog.getAttribute('aria-expanded') !== 'true';
      expanded[h] = on;
      tog.setAttribute('aria-expanded', on ? 'true' : 'false');
      var body = tog.nextElementSibling;
      if (body) body.hidden = !on;
      tog.parentNode.classList.toggle('is-open', on);
      return;
    }
    var more = e.target.closest('[data-ol-x-more]');
    if (more) {
      var hm = more.getAttribute('data-ol-x-more');
      showAll[hm] = !showAll[hm];
      var list = more.previousElementSibling;
      if (list) Array.prototype.forEach.call(list.children, function (li, i) { li.hidden = !showAll[hm] && i >= 3; });
      var n = list ? list.children.length - 3 : 0;
      more.textContent = showAll[hm] ? 'Show fewer' : 'Show ' + n + ' more';
      return;
    }
    var rm = e.target.closest('.ajaxcart__remove');
    if (rm) {
      e.preventDefault();
      /* Remove by the line's own key, never by its position, so a basket that has just moved can't take out the wrong line */
      var row = rm.closest('.ajaxcart__row');
      var keyEl = row && row.querySelector('[data-id]');
      var key = keyEl && keyEl.getAttribute('data-id');
      if (!key) { unlock(); return; }
      row.classList.add('is-removing');
      fetch(base() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (c) {
          /* An included item can't really be removed (the basket lock puts it back and explains why), so only say "Removed" for anything else */
          var art = row.closest('.ajaxcart__product');
          if (!(art && art.classList.contains('ol-ci--gift'))) status('Removed ' + ((row.querySelector('.ol-ci__name') || {}).textContent || 'item').trim(), 'rm');
          reload();
        })
        .catch(function () { row.classList.remove('is-removing'); reload(); });
      return;
    }
    var clr = e.target.closest('[data-ol-clear]');
    if (clr) {
      e.preventDefault();
      var box = clr.closest('.ol-cart__clearbox');
      if (!box) return;
      var act = clr.getAttribute('data-ol-clear');
      if (act === 'ask') { box.classList.add('is-asking'); unlock(); var yes = box.querySelector('[data-ol-clear="yes"]'); if (yes) yes.focus(); return; }
      if (act === 'no') { box.classList.remove('is-asking'); unlock(); return; }
      if (act === 'yes') {
        fetch(base() + 'cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function () { expanded = {}; showAll = {}; status('Your basket is now empty', 'rm'); reload(); })
          .catch(function () { reload(); });
      }
      return;
    }
    var add = e.target.closest('[data-ol-add]');
    if (add && !add.disabled) {
      e.preventDefault();
      var item = { id: Number(add.getAttribute('data-ol-add')), quantity: 1 };
      var tub = add.getAttribute('data-ol-tub');
      if (tub) item.properties = { 'Hot tub': tub };
      add.disabled = true;
      add.classList.add('is-busy');
      fetch(base() + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (d) {
          add.classList.remove('is-busy');
          add.classList.add('is-done');
          status('Added ' + (add.getAttribute('data-ol-name') || 'to your basket'));
          quietAdd = true;
          var jq = $();
          if (window.ajaxCart && typeof ajaxCart.load === 'function') ajaxCart.load();
          if (jq) jq(document.body).trigger('afterAddItem.ajaxCart', [d]);
          if (typeof window.olUpdateCartCount === 'function') window.olUpdateCartCount();
        })
        .catch(function (err) {
          unlock();
          add.disabled = false;
          add.classList.remove('is-busy');
          var row = add.closest('.ol-x__row');
          if (row && !row.querySelector('.ol-x__err')) {
            var p = document.createElement('small');
            p.className = 'ol-x__err';
            p.textContent = (err && err.description) || 'Sorry, that could not be added. Please try again.';
            row.appendChild(p);
          }
        });
    }
  });

  /* The basket note (ol-campaign-offers.js, e.g. "The IcePOD comes with your Comfort…") gets a close button.
     It still hides by itself after a few seconds. */
  function noteX() {
    var note = document.getElementById('ol-cart-note');
    if (!note || note.querySelector('.ol-cart-note__x')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ol-cart-note__x';
    b.setAttribute('aria-label', 'Close message');
    b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
    b.addEventListener('click', function () {
      note.classList.remove('ol-cart-note--visible');
      try { sessionStorage.removeItem('olCartNote'); } catch (er) { /* ignore */ }
    });
    note.appendChild(b);
  }
  if (window.MutationObserver) {
    var noteObs = new MutationObserver(function () {
      var n = document.getElementById('ol-cart-note');
      if (n && !n.__olx) { n.__olx = true; noteObs.observe(n, { childList: true }); }
      noteX();
    });
    var watchNotes = function () { noteObs.observe(document.body, { childList: true }); var n = document.getElementById('ol-cart-note'); if (n) { n.__olx = true; noteObs.observe(n, { childList: true }); noteX(); } };
    if (document.body) watchNotes(); else document.addEventListener('DOMContentLoaded', watchNotes);
  }

  /* Loading line while the basket is busy */
  function busy() {
    var b = document.body;
    root.classList.toggle('is-busy', !!(b && b.classList.contains('drawer--is-loading')) || html.classList.contains('ol-cart-syncing'));
  }
  if (window.MutationObserver) {
    var mo = new MutationObserver(busy);
    var watch = function () { if (document.body) mo.observe(document.body, { attributes: true, attributeFilter: ['class'] }); mo.observe(html, { attributes: true, attributeFilter: ['class'] }); };
    if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
  }
}());
